import { ICreatePromoProgramParams } from "@/core/repositories/promotion/IPromoDetail.repository";
import { PromoDetail } from "@/core/entities/promotion/PromoDetail";
import { createPromoProgramAtom, promoDetailIsCreatingAtom } from "@/store/promotion";
import { useAtomValue, useSetAtom } from "jotai";
import { useCallback } from "react";

export function useCreatePromoProgram() {
  const isCreating = useAtomValue(promoDetailIsCreatingAtom);
  const createPromoProgramAction = useSetAtom(createPromoProgramAtom);

  const createPromoProgram = useCallback(
    (params: ICreatePromoProgramParams): Promise<PromoDetail> => createPromoProgramAction(params),
    [createPromoProgramAction]
  );

  return {
    isCreating,
    createPromoProgram,
  };
}
